import { render, staticRenderFns } from "./teamManage.vue?vue&type=template&id=2ab282a1&scoped=true&"
import script from "./teamManage.vue?vue&type=script&lang=js&"
export * from "./teamManage.vue?vue&type=script&lang=js&"
import style0 from "./teamManage.vue?vue&type=style&index=0&id=2ab282a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab282a1",
  null
  
)

export default component.exports